<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Sparkle Filled" class="d-icon d-icon--sparkle-filled" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M9.263 11c.05 0 .093-.034.108-.082.23-.745.81-1.335 1.545-1.572A.12.12 0 0 0 11 9.233a.12.12 0 0 0-.084-.114c-.72-.232-1.29-.8-1.53-1.522a.131.131 0 0 0-.123-.092.131.131 0 0 0-.123.092 2.392 2.392 0 0 1-1.51 1.516.127.127 0 0 0-.087.12c0 .055.036.103.087.12a2.393 2.393 0 0 1 1.525 1.565.114.114 0 0 0 .107.082Zm-4.76-1.392a.23.23 0 0 0 .218-.166A4.872 4.872 0 0 1 7.868 6.24c.1-.033.17-.125.17-.23a.243.243 0 0 0-.17-.23 4.87 4.87 0 0 1-3.115-3.103.266.266 0 0 0-.25-.186.266.266 0 0 0-.25.186 4.872 4.872 0 0 1-3.076 3.09A.257.257 0 0 0 1 6.01c0 .111.073.208.177.243a4.872 4.872 0 0 1 3.107 3.19.23.23 0 0 0 .219.165Zm4.76-5.113c.05 0 .094-.034.108-.081.23-.746.81-1.335 1.545-1.572A.12.12 0 0 0 11 2.728a.12.12 0 0 0-.084-.114 2.388 2.388 0 0 1-1.529-1.522A.131.131 0 0 0 9.264 1a.131.131 0 0 0-.124.092 2.393 2.393 0 0 1-1.509 1.516.127.127 0 0 0-.087.12c0 .055.036.103.087.12a2.393 2.393 0 0 1 1.525 1.566.114.114 0 0 0 .108.081Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSparkleFilled',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
